import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';

class Landing extends Component {
    render() {
        return (
            <div className="page-landing">
                <Grid className="landing-grid">
                    <Cell col={12}>
                        <img
                            src="https://s3-ap-southeast-2.amazonaws.com/portfoliobucket.joseph/myAvatar.png"
                            alt="Joseph Johney"
                            className="avatar-image"
                        />
                        <div className="banner-text">
                            <h1 className="banner-headline">Solution Designer | Enterprise Architecture & Cloud</h1>
                            <hr />
                            <p>AWS | Azure | Google Cloud | Enterprise Architecture | API Strategy | Solution Design</p>
                            <p>Banking & Financial Services | Telecom | Cloud Strategy | Microservices | Event-Driven Design</p>
                            <p>Java | Spring Boot | Apigee | Mulesoft | NodeJS | ReactJS | Salesforce | Vlocity</p>
                            <div className="social-links">
                                <a href="https://www.linkedin.com/in/josephjohney/" rel="noopener noreferrer" target="_blank" aria-label="LinkedIn">
                                    <i className="fa fa-linkedin-square" aria-hidden="true" />
                                </a>
                                <a href="https://josephjohney.github.io/" rel="noopener noreferrer" target="_blank" aria-label="GitHub">
                                    <i className="fa fa-github-square" aria-hidden="true" />
                                </a>
                                <a href="http://google.com" rel="noopener noreferrer" target="_blank" aria-label="FreeCodeCamp">
                                    <i className="fa fa-free-code-camp" aria-hidden="true" />
                                </a>
                                <a href="http://google.com" rel="noopener noreferrer" target="_blank" aria-label="YouTube">
                                    <i className="fa fa-youtube-square" aria-hidden="true" />
                                </a>
                            </div>
                        </div>
                    </Cell>
                </Grid>
            </div>
        );
    }
}

export default Landing;
